import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import {
  CircularProgress,
} from "@mui/material";


// Get progress bar color based on status
  export const getProgressColor = (uploadStatus:any) => {
    switch (uploadStatus) {
      case "uploading":
        return "primary"; // Blue
      case "success":
        return "success"; // Green
      case "error":
        return "error"; // Red
      default:
        return "primary";
    }
  };

  // Get status icon
  export const getStatusIcon = (uploadStatus:any) => {
    switch (uploadStatus) {
      case "uploading":
        return <CircularProgress size={20} />;
      case "success":
        return <CheckCircleIcon style={{ color: "#4caf50" }} />;
      case "error":
        return <ErrorIcon style={{ color: "#f44336" }} />;
      default:
        return null;
    }
  };

  // Get status text
  export const getStatusText = (uploadStatus:any, currentFileName:any) => {
    switch (uploadStatus) {
      case "uploading":
        return `Uploading ${currentFileName}...`;
      case "success":
        return `${currentFileName} uploaded successfully`;
      case "error":
        return `${currentFileName} upload failed`;
      default:
        return "";
    }
  };